// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605130546/js/" + chunkId + "." + {"44":"ebf1a406","225":"a701c38e","481":"4b198ba1","486":"613ab73d","770":"39ddfd37"}[chunkId] + ".0.7979766255433176.chunk.js";
};